import React, { Component } from "react";
import { API_TOKEN_NAME, IMAGE_URL } from "../../constants";
import { Route } from "react-router-dom";
import { scAxiosAdmin } from "../..";
import Header from "../../component/frontend/Header";
import Footer from "../../component/frontend/Footer";
import banner_img from "../../images/banner-profile.jpg";
import { Helmet } from "react-helmet";
import SEO from "../../component/Seo";
const getSinglePublication = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request(
      "/publications/getsinglepublications/" + id,
      {
        method: "get",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
      }
    );
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
class SinglePublication extends Component {
  state = {
    publication_title: "",
    publication_pic: "",
    publication_desc: "",
    pdf_url: "",
  };
  handleChange = (event) => {
    this.setState({
      [event.target.name]: event.target.value,
    });
  };
  refreshgetSinglePublication = () => {
    let publication_title_string = this.props.match.params.name;
    //let new_publication_title = publication_title_string.replaceAll('-', ' ');
    let publication_id = publication_title_string.split("~").pop();
    getSinglePublication(publication_id)
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          let fullComponent = res.data.publications_desc;
          const pattern = /href="([^"]+)"/;
          let pdfUrl = fullComponent.match(pattern);
          if (pdfUrl && pdfUrl.length > 1) {
            const url = pdfUrl[1];
            this.setState({ pdf_url: url });
          } else {
            console.log("URL not found in the input string.");
          }
          this.setState({
            publication_title: records.publications_title,
            publication_desc: records.publications_desc,
            publication_pic: records.publications_pic,
          });
        } else {
          this.setState({
            publication_title: "",
            publication_desc: "",
            publication_pic: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  componentDidMount() {
    this.refreshgetSinglePublication();
  }
  render() {
    return (
      <div>
        <SEO
          title={
            this.state.publication_title +
            " | Best Hospital in Bangladesh | United Hospital"
          }
          description={{ __html: this.state.publication_desc }}
          pathSlug="/"
          keywords="publication, SinglePublication"
        />
        <Helmet>
          <meta
            name="description"
            content="United Hospital Ltd was borne out of a vision to provide a complete and one-stop healthcare solution to the people of Bangladesh."
          />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "http://schema.org",
              "@type": "LocalBusiness",
              name: "United Hospital Limited",
              image:
                "https://media.dhakatribune.com/uploads/2018/01/WEB_united-Hospital_Facebook-Edited_11.01.2018.jpg",
              telephone: "10666",
              email: "info@uhlbd.com",
              address: {
                "@type": "PostalAddress",
                streetAddress: "plot 15, Road 71, Gulshan",
                addressLocality: "Dhaka",
                addressRegion: "Dhaka",
                addressCountry: "Bangladesh",
                postalCode: "1212",
              },
              openingHoursSpecification: {
                "@type": "OpeningHoursSpecification",
                opens:
                  "Please insert valid ISO 8601 date/time here. Examples: 2015-07-27 or 2015-07-27T15:30",
              },
              url: "http://www.uhlbd.com/",
              aggregateRating: {
                "@type": "AggregateRating",
                ratingValue: "3.9",
                bestRating: "5",
                worstRating: "1",
                ratingCount: "756",
              },
              review: {
                "@type": "Review",
                author: {
                  "@type": "Person",
                  name: "abdul kahar",
                },
                datePublished: "2019-02-12",
                reviewRating: {
                  "@type": "Rating",
                  ratingValue: "3.9",
                  bestRating: "5",
                  worstRating: "1",
                },
                reviewBody:
                  "United Hospital is the best, friendly doctors & staff, very modern and Clean Environment. Offers you World class medical services and treatment facilities. Had Experienced back 2014 ( UK. patient)",
              },
            })}
          </script>
          <meta
            name="Subject"
            content="Accident & Emergency,Anesthesiology,Cancer Surgery (OncoSurgery),CARDIAC ANESTHESIA,Cardiac Surgery,Cardiology,Critical Care, Dentistry,Dermatology,Diabetes & Endocrinology,Dietetics & Nutrition,ENT & Head Neck Surgery,Family Medicine, Gastroenterology & Hepatology,General Surgery,Health Screening,Hemodialysis,Internal Medicine,Laboratory, Laparoscopic Surgery,Neurology,Nuclear Medicine,Oncology,Plastic Surgery,Physical Medicine & Rehabilitation,Vaccination Centre,Vascular Surgery"
          />
          <meta name="Abstract" content="one-stop healthcare in Bangladesh" />
          <meta name="Googlebot" content="all" />
          <meta http-equiv="imagetoolbar" content="no" />
          <meta name="robots" content="index, follow" />
          <meta name="copyright" content="Copyright &copy; uhlbd.com" />
          <meta name="owner" content="United Hospital" />
          <meta name="author" content="dcastalia.com" />
          <meta name="Rating" content="General" />
          <meta name="distribution" content="Global" />
          <meta
            name="classification"
            content="Patient info,For Physicians,Departments,Services,Gallery,News & Events,Publication etc."
          />
          <meta name="apple-mobile-web-app-capable" content="yes" />
          <meta
            names="apple-mobile-web-app-status-bar-style"
            content="black-translucent"
          />
          <meta
            name="msvalidate.01"
            content="16C4E0B16E39354E550F64BD707F6A97"
          />
        </Helmet>

        <Route component={Header} />
        <div
          id="giveMargin"
          className=""
          style={{ backgroundColor: "#fef3e9" }}
        >
          <section className="banner-hero">
            {this.state.publication_pic ? (
              <img
                src={
                  IMAGE_URL + "PublicationsImg/" + this.state.publication_pic
                }
                alt="banner-profile"
                className="w-100"
                style={{ "max-height": "450px",objectFit:"cover" }}
              />
            ) : (
              <img src={banner_img} alt="banner-profile" className="w-100" />
            )}
          </section>
          <section className="prof-dr">
            <div className="container">
              <div className="box-of-about mt-4 pb-4">
                <div className="row">
                  <div className="col-lg-12 col-md-12">
                    <div className="text-profile">
                      <h2>{this.state.publication_title}</h2>
                      <p
                        className="text-chnage"
                        dangerouslySetInnerHTML={{
                          __html: this.state.publication_desc,
                        }}
                      ></p>
                      {this.state.pdf_url ? (
                        <div style={{ position: "relative" }}>
                          <iframe
                            src={`https://docs.google.com/viewer?url=${encodeURIComponent(
                              this.state.pdf_url
                            )}&embedded=true`}
                            width="100%"
                            height="800px"
                            title="PDF Viewer"
                            sandbox="allow-same-origin allow-scripts"
                            style={{ border: "1px solid black" }}
                          />
                          <a
                            className="fa-solid fa-download"
                            style={{
                              position: "absolute",
                              top: 20,
                              right: 80,
                              fontSize: "30px",
                            }}
                            href={this.state.pdf_url}
                            download
                          ></a>
                        </div>
                      ) : (
                        <div className="d-flex justify-content-center">
                          <div
                            className="spinner-border text-primary"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
        <Route component={Footer} />
      </div>
    );
  }
}
export default SinglePublication;



// WEBPACK FOOTER //
// ./src/component/frontend/singlepublication.js